import React from "react";
import { Link } from "react-router-dom";

export default function AboutFounderSection({ data }) {
  if (!data) {
    return null;
  }

  return (
    <section className="about-founder-section">
      <div className="container">
        <div className="row align-items-center about-founder-section-main">
          <div className="col-lg-6">
            <img
              className="about-founder-section-image"
              src={data.image}
              alt={data.imageAlt}
            />
          </div>

          <div className="col-lg-6">
            <div className="about-founder-section-content">
              <span className="main-title">{data.eyebrow}</span>
              <div className="heading">{data.heading}</div>

              <div className="about-founder-section-copy">
                {data.paragraphs.map((paragraph) => (
                  <p key={paragraph}>{paragraph}</p>
                ))}
              </div>

              <blockquote>{data.quote}</blockquote>

              {data.cta?.link && (
                <Link className="default-btn" to={data.cta.link}>
                  {data.cta.label}
                </Link>
              )}
            </div>
          </div>
        </div>

        <div className="row about-founder-section-stats">
          {data.stats.map((stat) => (
            <div className="col-lg-3 col-sm-6 col-6" key={stat.label}>
              <div className="about-founder-stat">
                <p>{stat.label}</p>
                <strong>{stat.value}</strong>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
